import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import EditIcon from '@material-ui/icons/Edit';
import SendIcon from '@material-ui/icons/Send';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

import Modal from '../../commons/Modal';
import Texto from '../../commons/Texto';
import Tabla from '../../commons/Tabla';
import {
  formatearFecha,
  formatoFecha,
  formatoMonetario,
  redondeoDecimales,
} from '../../commons/Utilitarios';
import '../../css/ordencompra.css';
import Boton from '../../commons/Boton';

const InventarioStock = ({ inline, title, inventory, onClose, onSend }) => {
  const [assets, setAssets] = useState([]);

  useEffect(() => {
    setAssets(inventory.lts.map((x) => ({ ...x, us: 0, edit: false })));
  }, []);

  const columnsLots = [
    {
      key: 'na',
      label: 'Almacen',
    },
    {
      key: 'lt',
      align: 'center',
      label: 'Lote',
    },
    {
      key: 'cc',
      align: 'center',
      label: 'Orden de compra',
    },
    {
      key: 'fi',
      align: 'right',
      label: 'Fecha de ingreso',
      content: (item) => formatoFecha(item.fi),
    },
    {
      key: 'us',
      align: 'center',
      label: 'Cantidad',
      content: (item) => (
        <div className="op-centrar-componentes">
          <AddIcon
            style={{ color: 'green', cursor: 'pointer' }}
            onClick={() => handleCantidadBienes(item.lt, item.na, 1)}
          />
          <div className={`cantidad${item.edit ? ' edit' : ''}`}>
            <span onClick={() => handleHabilitarEdicion(item.lt, !item.edit)}>
              {item.us}
            </span>
            <input
              type="text"
              value={item.us}
              onChange={(e) =>
                handleEditarCantidad(item.lt, item.na, e.target.value)
              }
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleHabilitarEdicion(item.lt, !item.edit);
                } else {
                  let re = new RegExp('[0-9]');
                  if (!re.test(e.key)) {
                    e.preventDefault();
                  }
                }
              }}
              onPaste={(e) => e.preventDefault()}
              onFocus={(e) => e.target.select()}
            />
            <div className="edicion">
              <EditIcon
                style={{ fontSize: '15px' }}
                onClick={() => handleHabilitarEdicion(item.lt, !item.edit)}
              />
            </div>
          </div>
          <RemoveIcon
            style={{ color: 'red', cursor: 'pointer' }}
            onClick={() => handleCantidadBienes(item.lt, item.na, -1)}
          />
        </div>
      ),
    },
    {
      key: 'sd',
      align: 'center',
      label: 'Stock disponible',
    },
  ];

  const handleCantidadBienes = (lt, na, valor) => {
    setAssets(
      assets.map((x) =>
        x.lt === lt && x.na === na
          ? {
              ...x,
              us:
                valor === -1 && x.us <= 1
                  ? 0
                  : handleValidateStock(
                      lt,
                      na,
                      parseInt(x.us ? x.us : 0) + valor,
                    ),
            }
          : x,
      ),
    );
  };

  const handleHabilitarEdicion = (lt, valor) => {
    setAssets(assets.map((x) => (x.lt === lt ? { ...x, edit: valor } : x)));
  };

  const handleEditarCantidad = (lt, na, valor) => {
    setAssets(
      assets.map((x) =>
        x.lt === lt && x.na === na
          ? {
              ...x,
              us:
                valor <= 0
                  ? handleValidateStock(lt, na, 1)
                  : handleValidateStock(lt, na, valor),
            }
          : x,
      ),
    );
  };

  const handleValidateStock = (lt, na, ct) => {
    let find = assets.find((x) => x.lt === lt && x.na === na);
    if (find === undefined) {
      return 0;
    } else {
      if (ct > find.sd) {
        return find.sd;
      }
      return ct;
    }
  };

  return (
    <>
      {inline ? (
        <>
          <div className="op-form-group op-col-1 view-ordencompra">
            <Tabla
              columns={columnsLots}
              data={assets}
              pagination={false}
              searcheable={false}
              hoverSelectedRow={false}
              style={{ padding: '0px' }}
            />
          </div>
        </>
      ) : (
        <Modal
          title={title}
          closePressEscape={false}
          closeWithoutConfirmation
          onClose={() => onClose()}
          onActions={() => (
            <>
              <Boton
                className="op-grabar"
                icon={() => <SendIcon />}
                tabIndex={21}
                onClick={() => {
                  inventory.lts = assets;
                  onSend(inventory);
                }}
              >
                Enviar
              </Boton>
            </>
          )}
        >
          <Texto
            name="cm"
            value={inventory.cm}
            label="C&oacute;digo"
            size={3}
            tabIndex={10}
            onChange={() => {}}
            disabled
          />
          <Texto
            name="ns"
            value={inventory.ns}
            label="Sucursal"
            size={3}
            tabIndex={11}
            onChange={() => {}}
            disabled
          />
          <Texto
            name="um"
            value={inventory.um}
            label="Unidad de medida"
            size={3}
            tabIndex={12}
            onChange={() => {}}
            disabled
          />
          <Texto
            name="sd"
            value={inventory.sd}
            label="Stock disponible"
            size={3}
            tabIndex={13}
            onChange={() => {}}
            restrict={'int'}
            disabled
          />
          <Texto
            name="mg"
            value={inventory.mg == '0' ? 'FIFO' : 'LIFO'}
            label="M&eacute;todo de gesti&oacute;n"
            size={3}
            tabIndex={14}
            onChange={() => {}}
            disabled
          />
          <Texto
            name="pv"
            value={`${inventory.tm == 0 ? 'S/' : '$'} ${formatoMonetario(redondeoDecimales(inventory.pv))}`}
            label="Precio de venta"
            size={3}
            tabIndex={15}
            onChange={() => {}}
            restrict={'money'}
            disabled
          />
          <div className="op-form-group op-col-1 view-ordencompra">
            <Tabla
              columns={columnsLots}
              data={assets}
              pagination={false}
              searcheable={false}
              hoverSelectedRow={false}
              style={{ padding: '0px' }}
            />
          </div>
        </Modal>
      )}
    </>
  );
};

InventarioStock.propTypes = {
  inventory: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
  inline: PropTypes.bool,
};

export default InventarioStock;
